import React, { useEffect } from 'react';
import { Translation } from 'react-i18next';
import { Typography } from 'antd';
import Logger from '../../../../../lib/Logger';
import LearningModuleList from '../../learnings/containers/LearningModuleListContainer';
import useWindowDimensions from '../../../../../lib/WindowDimensions';

const { Title } = Typography;

const LearningModuleSerieList = ({
  activeId,
  partnershipId,
  action,
  debouncedQuery,
  selectedTags,
  load,
  list,
  value,
  state,
  ...props
}) => {
  const { width } = useWindowDimensions();

  const isLarge = width > 992;
  const widthContainer = isLarge ? '70vw' : '92vw';

  useEffect(() => {
    const filter = { [action.split('_not')[0]]: value };

    if (state.length > 0) {
      filter['state'] = state.join(',');
    }

    if (debouncedQuery.trim() !== '') {
      filter['keyword'] = debouncedQuery;
    }

    if (selectedTags.length > 0) {
      filter['categories'] = selectedTags.join(',');
    }

    load(activeId, partnershipId, action, filter);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    activeId,
    partnershipId,
    action,
    debouncedQuery,
    selectedTags,
    load,
    state,
  ]);

  return (
    <Translation>
      {(t) => (
        <>
          {list.length > 0 ? (
            <>
              <Title level={3} className='learning-module-serie-title'>
                {t(`learning_module_serie_${action}`)}
              </Title>

              {list.map((x) => (
                <div key={x.id} style={{ width: widthContainer }}>
                  <Title level={3} className='learning-module-title'>
                    {x.title}
                  </Title>
                  <LearningModuleList
                    moduleSerieId={x.id}
                    action={action}
                    value={value}
                    selectedTags={selectedTags}
                    debouncedQuery={debouncedQuery}
                    state={state}
                  />
                </div>
              ))}
            </>
          ) : null}
        </>
      )}
    </Translation>
  );
};

export default LearningModuleSerieList;

Logger.log('silly', `LearningModuleSerieList loaded.`);
